import { render } from "./UpArrow.vue?vue&type=template&id=655a7479"
import script from "./UpArrow.vue?vue&type=script&lang=js"
export * from "./UpArrow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__